function ImageSlider(element) {
  this.element = element
  this.inner = this.element.find('.ImageSlider__inner')
  this.slides = this.element.find('.ImageSlider__slide')
  this.indicators = this.element.find('.ImageSlider__indicators')
  this.buttons = this.element.find('.ImageSlider__buttons')
  this.index = 0

  this.indicators.on('click', 'li', this.handleIndicatorClick.bind(this))
  this.buttons.on('click', 'a', this.handleButtonClick.bind(this))

  var count = this.slides.length
  var slideWidth
  if(window.innerWidth <= 992) {
      slideWidth = count * 600 + 1200
      if(window.innerWidth <= 768) {
          slideWidth = count * 400 + 800
      }
  } else {
      slideWidth = count * 760 + 1520
  }
  this.inner.css({
      'min-width': slideWidth + 'px',
  });

  if (this.slides.length > 1) {
    this.slides.last().clone().prependTo(this.inner)
    this.slides.first().clone().appendTo(this.inner)
  } 

  this.move()
}

ImageSlider.prototype.handleIndicatorClick = function(event) {
  this.index = parseInt($(event.target).attr('data-target'))
  this.move()
}

ImageSlider.prototype.handleButtonClick = function(event) {
  event.preventDefault()

  const slide = $(event.target).attr('data-slide')

  if (slide === 'next') {
    this.index = (this.index + 1)
  } else {
    this.index = (this.index - 1)
  }

  this.move()
}

ImageSlider.prototype.move = function() {
  var count = this.slides.length

  this.index = ((this.index % count) + count) % count

  var change = 0
  var slideWidth

  if(window.screen.width < 992) {
    slideWidth = count * 400 + 800
  }

  if (count > 1) {
    change = -1 * ((100 / (count + 2)) * ((this.index + 1) % (count + 2)))
  }

  this.inner.css({
    '-webkit-transform': 'translateX('+ change +'%)',
    '-moz-transform' : 'translateX('+ change +'%)',
    '-ms-transform': 'translateX('+ change +'%)',
    '-o-transform': 'translateX('+ change +'%)',
    'transform': 'translateX('+ change +'%)',
    'min-width': slideWidth + 'px',
  })

  this.updateActive()
}

ImageSlider.prototype.updateActive = function() {
  const indicators = this.indicators.find('li')
  indicators.removeClass('active')
  $('.ImageSlider__slide--active').removeClass('ImageSlider__slide--active')

  $(this.slides[this.index]).delay(600).addClass('ImageSlider__slide--active')
  $(indicators[this.index]).addClass('active')
}

$(document).ready(function() {
  $('.ImageSlider').each(function() {
    new ImageSlider($(this))
  })

  $('.brand-presentation.d-none .carousel-item').each(function() {
    var that = $(this)
    var next = that.next()
    var prev = that.prev()

    if (!next.length) {
      next = that.siblings(':first');
    }

    if (!prev.length) {
      prev = that.siblings(':last')
    }

    // find the original node
    next.children('[class="row"]')
        .clone()
        .addClass('carousel-item--preview carousel-item--preview--right')
        .appendTo(that)

    // find the original node
    prev.children('[class="row"]')
        .clone()
        .addClass('carousel-item--preview carousel-item--preview--left')
        .prependTo(that)
  })
})


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/modules/image-slider.js
// module id = 22
// module chunks = 0